import { useState } from "react";
import styled from "styled-components";

import useFilters from "./filters/useFilters";
import useProductSearch from "../../../../../clients/productSearch/useProductSearch";
import * as UI from "../../../../../modules/ui-kit";

export default function FilteredProducts(props) {
    const { ProductComponent, onSelect } = props;

    const [filters] = useFilters();
    const [prependedIds, setPrependedIds] = useState<string[]>([]);

    const products = useProductSearch(filters);

    if (!products.data) return "loading";

    function loadMore() {
        void products.fetchMore(
            {
                variables: {
                    page: {
                        first: 20,
                        after: products.data.searchProducts.results.pageInfo.endCursor,
                    },
                },
            }
        );
    }

    function handleDuplicate(newId: string) {
        setPrependedIds((prev) => [newId, ...prev]);
    }

    const searchIds = new Set(products.data.searchProducts.results.nodes.map((n) => n.id));
    const pendingIds = prependedIds.filter((id) => !searchIds.has(id));
    const allIds = [...pendingIds, ...products.data.searchProducts.results.nodes.map((n) => n.id)];

    const incompleteResultSet = products.data.searchProducts.results.totalCount > products.data.searchProducts.results.nodes.length;

    return (
        <Styled>
            <ol>
                {
                    allIds.map(
                        (id) => (
                            <li key={ id }>
                                <ProductComponent
                                    id={ id }
                                    onClick={ onSelect }
                                    onDuplicate={ handleDuplicate }
                                />
                            </li>
                        )
                    )
                }
            </ol>
            { incompleteResultSet && <UI.Button onClick={ loadMore }>Load more products</UI.Button> }
        </Styled>
    );
}

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;

    & > ol {
        list-style: none;
        margin: 0;
        padding: 0;

        & > li {
            padding: 0 4px 4px;

            &:not(:first-child) {
                border-top: 1px solid #00000007;
                padding-top: 4px;
            }
        }
    }
`;
